/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useEffect, useRef } from 'react';

export const useOnOutsideClick = (handleOutsideClick: () => void) => {
  const innerBorderRef = useRef<HTMLDivElement>(null);

  const onClick = (event: MouseEvent) => {
    const node = event.target as Node;
    if (innerBorderRef.current && !innerBorderRef.current.contains(node)) {
      handleOutsideClick();
    }
  };

  useEffect(() => {
    document.addEventListener('click', onClick, true);
    return () => {
      document.removeEventListener('click', onClick, true);
    };
  }, [innerBorderRef.current]);

  return { innerBorderRef };
};
